import React from "react";
import { Swords, QrCode, MonitorPlay, WifiOff, Languages } from "lucide-react";
import { useM } from "../useM";
import { Reveal, SectionHead } from "../ui";

const STRIP = [Swords, QrCode, MonitorPlay, WifiOff, Languages];

export const FeatureStrip = () => {
  const m = useM();
  return (
    <section className="border-y border-white/10 bg-mk-navy" data-testid="feature-strip">
      <div className="mx-auto grid max-w-7xl grid-cols-2 px-6 sm:grid-cols-3 lg:grid-cols-5 lg:px-10">
        {STRIP.map((Icon, i) => (
          <div key={i} className="flex items-center gap-3 border-white/10 py-6 lg:border-l lg:pl-6 lg:first:border-l-0 lg:first:pl-0">
            <Icon size={18} className="shrink-0 text-mk-yellow" />
            <span className="font-mono-t text-xs uppercase tracking-wider text-white/80">{m(`strip.${i + 1}`)}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export const Pillars = () => {
  const m = useM();
  return (
    <section className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40" data-testid="pillars-section">
      <SectionHead eyebrow={m("home.pillarsEyebrow")} title={m("home.pillarsTitle")} />
      <div className="mt-20 grid gap-12 md:grid-cols-3 md:gap-8">
        {[1, 2, 3].map((n, i) => (
          <Reveal key={n} delay={i * 0.1} className="group border-t border-white/15 pt-8 transition-colors hover:border-mk-yellow">
            <span className="font-mono-t text-sm text-mk-yellow">0{n}</span>
            <h3 className="mt-6 font-heading text-3xl font-bold uppercase text-white">{m(`pillar${n}.t`)}</h3>
            <p className="mt-4 text-sm leading-relaxed text-mk-muted md:text-base">{m(`pillar${n}.d`)}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
